import restUtils from "core/utils/rest";
import { kycReferenceItem, kycReferenceItemTransformer, investorKycDetailTransformer } from "./transformers/kyc";


export const getKycReferenceList = (): Promise<kycReferenceItem[]> => {
  const url = "hubwise-api/aml/kyc/reference-list";
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.payload.map(kycReferenceItemTransformer);
  });
};

export const getInvestorKyc = (investorId: string) => {
  const url = `hubwise-api/ims/investor/${investorId}/kyc`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return investorKycDetailTransformer(response.payload);
  });
};
